import i18n from "i18next";
import * as yup from "yup";

import { Shape } from "@/core/yup";
import { validateBankAccount } from "@/validations";

import { FinanceFormTypes } from "./FinanceForm";

export const formSchema = () =>
    yup.object<{}, Shape<FinanceFormTypes>>({
        number: yup
            .string()
            .requiredIf("type")
            .test("accountNumber", i18n.t("Validations.Format"), function testAccountNumber() {
                const { type, number } = this.parent;
                return validateBankAccount(type, number);
            }),
    });
